import Root from './components/Root';
export var OuraConsentManager = Root;
